<div class="container">
  <!-- section title -->
  <h2 class="section-title wow fadeIn">Service Packages</h2>

  <div class="spacer-60"></div>

  <div class="row">
    <div class="col-md-4 pr-md-0 mt-md-4 mt-0">
      <!-- price item -->
      <div class="price-item bg-white rounded shadow-dark text-center">
        <img src="assets/images/price-1.svg" alt="Basic" />
        <h2 class="plan">Basic Web Development</h2>
        <p>1 simple page with 4 to 5 sections, utilizing HTML, CSS, and JavaScript. Responsive design using Bootstrap and Tailwind CSS.</p>
        <p>2 Days Delivery</p>
        <h3 class="price"><em>$</em>10<span>Hour</span></h3>
        <a href="javascript:" class="btn btn-default">Get Started</a>
      </div>
    </div>

    <div class="col-md-4 px-md-0 my-4 my-md-0">
      <!-- price item recommended-->
      <div class="price-item bg-white rounded shadow-dark text-center best">
        <span class="badge">Recommended</span>
        <img src="assets/images/price-2.svg" alt="Premium" />
        <h2 class="plan">Premium Web Solutions</h2>
        <p>Unlimited products, api integrations, and advanced features leveraging Angular for dynamic user experiences.</p>
        <p>Mon-Fri Support</p>
        <h3 class="price"><em>$</em>49<span></span></h3>
        <a href="javascript:" class="btn btn-default">Get Started</a>
      </div>
    </div>

    <div class="col-md-4 pl-md-0 mt-md-4 mt-0">
      <!-- price item -->
      <div class="price-item bg-white rounded shadow-dark text-center">
        <img src="assets/images/price-3.svg" alt="Ultimate" />
        <h2 class="plan">Ultimate Web Solutions</h2>
        <p>An optimal choice for large companies and individuals, providing 24/7 support with expertise in HTML, CSS, Bootstrap, Tailwind, and Angular.</p>
        <p>24/7 Support</p>
        <h3 class="price"><em>$</em>99<span></span></h3>
        <a href="javascript:" class="btn btn-default">Get Started</a>
      </div>
    </div>
  </div>
</div>
